import { render, staticRenderFns } from "./voaform.vue?vue&type=template&id=223c5132&scoped=true"
import script from "./voaform.vue?vue&type=script&lang=js"
export * from "./voaform.vue?vue&type=script&lang=js"
import style0 from "./voaform.vue?vue&type=style&index=0&id=223c5132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c5132",
  null
  
)

export default component.exports